import { LiveVideo } from '@/features/livestream/shared';
import { City, PagePath } from '@/layouts/shared';
import { createHandle, getLiveVideoImage } from '@/libs/app';
import { TFunction } from 'next-i18next';
import React from 'react';
import { Link, Image, Icon, ViewIcon, Avatar } from '@/components';
import { LiveStreamStatus } from '@/features/livestream/detail/const';
import { humanDateTimeFromNow } from '@/libs/dayjs';
type VideoLoopProps = {
  v: LiveVideo;
  t: TFunction;
  showBell?: boolean;
};
export const VideoLoop = ({ v, t, showBell }: VideoLoopProps) => {
  const { images, name: live_title, id, viewer, live_streamer, start_datetime, duration, status, city } = v;
  const { name, avatar } = live_streamer || {};
  let handle = `${createHandle(live_title)}-${id}`;
  return (
    <Link
      key={id}
      className="tw-w-full tw-z-0  tw-block tw-relative tw-border tw-rounded-5 tw-border-gray-31  hover:tw-border-primary-main tw-duration-500 tw-ease-linear"
      url={{ pathname: PagePath.LiveVideoPage, query: { id: handle } }}
    >
      {showBell && (
        <Image
          alt="bell"
          src="/ico_bell.svg"
          className="!tw-absolute tw--right-3 tw--top-4 tw-w-9 tw-h-9 tw-z-11"
        ></Image>
      )}

      <div className="tw-w-full tw-relative tw-pb-55-percent tw-rounded-t-5 tw-overflow-hidden">
        <Image
          alt={name}
          src={getLiveVideoImage(images)}
          className="tw-w-full tw-h-full !tw-absolute tw-left-0 tw-top-0"
        />
        <div
          className="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-z-1"
          style={{
            background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 66.74%, #000000 151.27%)',
            transform: 'rotate(-180deg)',
          }}
        ></div>
        <div
          className="tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full tw-z-1"
          style={{
            background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 71.7%, #000000 113.56%)',
          }}
        ></div>

        <div className="tw-z-11 tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-right-0 tw-text-white">
          <div className="tw-flex tw-flex-col tw-h-full tw-justify-between tw-p-2">
            <div className="tw-flex tw-gap-x-1 tw-items-center">
              {status === LiveStreamStatus.LIVE_NOW && (
                <div className="tw-flex tw-items-center tw-px-4 tw-bg-red-600 tw-text-white tw-font-xs tw-rounded tw-mr-2">
                  <span className="tw-w-2 tw-h-2 tw-rounded-full tw-bg-white tw-mr-1 tw-block"></span>
                  Live
                </div>
              )}
              <Icon icon={<ViewIcon />} className="tw-w-5 tw-h-5" />
              <p className=" tw-text-sm">{viewer}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="tw-flex tw-flex-col tw-gap-y-1  tw-px-4 tw-py-4 tw-bg-white tw-rounded-b-5 tw-overflow-hidden">
        <div className="tw-flex tw-gap-x-2 tw-items-center tw-text-secondary-70 tw-font-medium">
          <Avatar src={avatar} className="tw-w-6 tw-h-6" rounded="tw-rounded-full" />
          <h3 dangerouslySetInnerHTML={{ __html: name }}></h3>
        </div>
      </div>
    </Link>
  );
};
